
(function () {
	'use strict';
    
    // Sélectionner tous les éléments checkbox du filtre de produits
    const listItems = document.querySelectorAll('.bapf_sfilter.bapf_ckbox ul li');
    const checkboxIds = [];
    listItems.forEach(li => {
        const checkbox = li.querySelector('input[type="checkbox"]');
        checkboxIds.push(checkbox.id);
    });

    document.addEventListener("click", function(e) {
        if(checkboxIds.includes(e.target.id)){
            if (e.target.checked) {
                e.target.parentElement.classList.add('checked');
            } else {
                e.target.parentElement.classList.remove('checked');
            }
            
        }
    });
})();
